<template lang="pug">
.print-labels.inside-padding
  h2.title Imprimir Etiquetas
  form(@submit.prevent="" autocomplete="off")
    .center(ref="Layout")
      .print-layout.center(:style="dataForm.quantity > 1 ? `width:${dataForm.containerWidth}; padding:0 ${dataForm.padding}` : ''")
        .center.line(v-for="n in dataForm.quantity")
          .label-code(:style="buildStyleShape(dataForm.width, dataForm.height)")
            .shape-label(v-for="(shape, index) in dataForm.shapes" :style="buildStyleShape(shape.width, shape.height, shape.top, shape.left)")

            .code-label.left(v-for="(qrcode, index) in dataForm.qrcodes" :style="buildStyleString('', '', qrcode.top, qrcode.left, qrcode.degrees)")
              QRCode(:text="qrcode.text" :width="qrcode.width")

            .string-label.center.uppercase(v-for="(string, index) in dataForm.strings" :style="buildStyleString(string.width, string.height, string.top, string.left, string.degrees)" :class="{dark: string.bold}") {{ string.testText }}

            .code-label.left(v-for="(code, index) in dataForm.codes" :style="buildStyleString(code.width, code.height, code.top, code.left, code.degrees)")
              .font-128 {{ code128(code.testText) }}

            img.image-label(v-for="(image, index) in dataForm.images" :src="`${imagePath}/${image.folder}/${image.name}`" :alt="image.name" :style="buildStyleShape(image.width, image.height, image.top, image.left, image.degrees)")

    .print-list-container
      .print-list-row(v-for="(product, index) in products")
        .input-container
          input.input.input-reference(v-model="product.product" autocomplete="ño" @input="addProduct(index)")
          label.label(:class="{ show: product.product }") Referencia
        .input-container(v-for="size in sizes")
          input.input.input-quantity(v-model.number="product.sizes[size]" type="number" min="0" max="200" autocomplete="ño")
          label.label.uppercase(:class="{ show: Number.isInteger(product.sizes[size]) }") {{ size }}

    shActionButton(:isForm="true" text="Crear Impresión" textRunning="Creando Impresión" :action="goPrint")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import gqlProduct from '@/graphql/product'
import gql from '@my/graphql'
import router from '@my/router'
import QRCode from '@/components/elements/QRCode'

export default {
  name: 'PrintLabels',

  mixins: [mForm, mFilters],

  components: { QRCode },

  data () {
    return {
      dataForm: {
      },
      products: [{
        product: '',
        sizes: {},
        quantity: 0
      }],
      gql: gqlProduct
    }
  },

  mounted () {
    this.dataForm = this.$store.state.print.label
  },

  methods: {
    addProduct (index) {
      if (!this.products[index + 1] && this.products[index].product) {
        this.products.push({
          product: '',
          sizes: {},
          quantity: 0
        })
      }

      if (!this.products[index].product && this.products[index + 1] && !this.products[index + 1].product) {
        this.products.splice(index + 1, 1)
      }
    },
    async getByProduct () {
      const query = gqlProduct.GET_BY_PRODUCT
      const product = this.product.product.toLowerCase()

      const response = await gql.query(query, { product })

      if (!response) {
      } else {
        if (response.data && !response.data.getByProduct) {
          this.product.article = ''
          this.product.person = ''
          this.product.design = ''
        } else {
          const product = response.data.getByProduct

          this.product.article = product.article
          this.product.person = product.person
          this.product.design = product.design
        }
      }
    },

    goPrint () {
      this.$store.commit('initProductLabel')
      let productsQuantity = 0

      this.products.forEach(product => {
        let quantity = 0
        for (const key in product.sizes) {
          const quantitySize = product.sizes[key]
          quantity += quantitySize
        }

        if (quantity > 0) {
          product.quantity = quantity
          this.$store.commit('setProductLabel', product)
          productsQuantity++
        }
      })

      if (productsQuantity) router.goToPageToPrint()
    },

    buildStyleShape (width, height, top, left, degrees) {
      const style = {
        width: width ? `width:${width};` : '',
        height: height ? `height:${height};` : '',
        top: top ? `top:${top};` : '',
        left: left ? `left:${left};` : '',
        degrees: degrees ? `transform: rotate(${degrees});` : ''
      }

      return `${style.width}${style.height}${style.top}${style.left}${style.degrees}`
    },

    buildStyleString (width, height, top, left, degrees) {
      const style = {
        width: width ? `width:${width};` : '',
        height: height ? `font-size:${height};` : '',
        top: top ? `top:${top};` : '',
        left: left ? `left:${left};` : '',
        degrees: degrees ? `transform: rotate(${degrees});` : ''
      }

      return `${style.width}${style.height}${style.top}${style.left}${style.degrees}`
    }
  },

  computed: {
    sizes () {
      return this.$store.state.variables.sizes
    }
  }
}
</script>

<style lang="stylus">
.print-labels
  position relative
  padding-bottom 1em

.print-layout
  display inline-flex
  justify-content space-between

.add-panel
  display flex
  justify-content space-between
  align-items center

.label-code
  background-color white
  display inline-block
  position relative
  overflow hidden

.shape-label
  background-color black
  position absolute
  transform-origin top left

.string-label
  color black
  position absolute
  text-align center
  white-space nowrap
  transform-origin top left

.code-label
  color black
  position absolute
  white-space nowrap
  transform-origin top left

.image-label
  position absolute
  box-sizing initial
  transform-origin top left

.print-list-container
  overflow-x scroll
  margin 2em 0 1em 0
  text-align left

.print-list-row
  display inline-flex
  gap .5em

.print-list-row .input-container
  font-size 8px
  margin 0

.print-list-row .input-container input
  font-weight 600

.input-reference
  width 200px

.input-quantity
  width 50px
</style>



// WEBPACK FOOTER //
// src/components/pages/print/PrintLabels.vue